import bgDesktop from "assets/images/bg-home-lg.svg";
import bgMobile from "assets/images/bg-home.svg";
import { Logo } from "components";
import { config } from "constant";
import { useRef } from "react";
import { Fragment } from "react/jsx-runtime";
import CheckMore from "./CheckMore";
import Download from "./Download";
import DynamicLink from "./DynamicLink";
import LastSection from "./LastSection";
import MainSection from "./MainSection";

export default function Home() {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const scrollToCheckMore = () => {
    const duration = 800;
    const targetElement = buttonRef.current;
    if (!targetElement) return;
    const startPosition = window.scrollY;
    const targetPosition =
      targetElement.getBoundingClientRect().top + startPosition;
    const distance = targetPosition - startPosition;
    let startTime: number | null = null;
    const easeInOutQuad = (t: number) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    const animateScroll = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      window.scrollTo(0, startPosition + distance * easeInOutQuad(progress));
      if (timeElapsed < duration) requestAnimationFrame(animateScroll);
    };
    requestAnimationFrame(animateScroll);
  };
  return (
    <Fragment>
      <div className="absolute w-full lg:max-w-[75rem] top-8 lg:top-[50vh] lg:-translate-y-1/2 left-0 right-0 mx-auto z-[-1]">
        <picture>
          <source media="(min-width:1024px)" srcSet={bgDesktop} />
          <source media="(min-width:0px)" srcSet={bgMobile} />
          <img
            src={bgMobile}
            alt={config.title}
            className="w-full pointer-events-none opacity-55"
          />
        </picture>
      </div>
      <main className="w-full px-5 pt-2 lg:pt-8">
        <header className="w-fit h-fit mx-auto p-2 rounded-2xl backdrop-blur-[1.25rem] sticky top-2 z-10">
          <Logo
            variant="logo-main"
            className="block max-w-full h-[3.125rem] object-contain"
          />
        </header>
        <div className="w-full min-h-[calc(100svh-9.625rem)] flex flex-col pt-4">
          <span className="flex-1" />
          <MainSection />
          <Download />
          <section className="w-full flex items-center justify-center mt-10">
            <Logo variant="DEFAULT-2" className="w-14 lg:w-[6.375rem]" />
          </section>
          <DynamicLink />
          <span className="flex-1" />
          <h2 className="block w-fit text-center text-xl text-gradient font-semibold font-gilroy mx-auto mt-24 animate-bounce">
            <button ref={buttonRef} type="button" onClick={scrollToCheckMore}>
              Check more
            </button>
          </h2>
        </div>
        <CheckMore onShowLess={scrollToCheckMore} />
        <section
          style={{
            background:
              "linear-gradient(98.15deg, #E8E8E8 2.44%, #FF629B 46.98%, #3E97FF 90.77%)",
          }}
          className="w-full min-h-[11.25rem] lg:min-h-[13.125rem] flex items-center rounded-[2.5rem] mt-5 p-4"
        >
          <p className="w-full text-xl lg:text-3xl text-white text-center font-medium font-gilroy whitespace-pre-wrap">
            Build Your Digital Business Card,{" "}
            <i className="font-bold">Smarter</i> and{" "}
            <i className="font-bold">Better</i> Than Ever!
          </p>
        </section>
        <LastSection />
      </main>
      <footer className="w-full text-[#353740] text-center text-xs font-medium py-11">
        © 2026 All rights reserved - Gataa studio
      </footer>
    </Fragment>
  );
}
